/**
 * Schémas pour le réseau interne — graphe de connexions inter-utilisateurs.
 *
 * Vague A.3. Chaque candidat peut déclarer qu'il connaît quelqu'un dans
 * une entreprise (inscrite ou non). Sert au "warm intro" sur les annonces.
 */
import { z } from 'zod';
import { uuidSchema } from './common.js';
export const CONNECTION_RELATION_TYPES = [
    'manager_actuel',
    'manager_ancien',
    'collegue_actuel',
    'collegue_ancien',
    'camarade_promo',
    'enseignant',
    'ancien_enseignant',
    'maitre_stage',
    'maitre_apprentissage',
    'autre',
];
export const CONNECTION_RELATION_LABELS = {
    manager_actuel: 'Manager actuel',
    manager_ancien: 'Ancien manager',
    collegue_actuel: 'Collègue actuel',
    collegue_ancien: 'Ancien collègue',
    camarade_promo: 'Camarade de promotion',
    enseignant: 'Enseignant',
    ancien_enseignant: 'Ancien enseignant',
    maitre_stage: 'Maître de stage',
    maitre_apprentissage: "Maître d'apprentissage",
    autre: 'Autre',
};
export const connectionRelationTypeSchema = z.enum(CONNECTION_RELATION_TYPES);
export const connectionCreateSchema = z.object({
    // Soit on lie à une entreprise inscrite (companyId), soit on saisit
    // librement un nom (companyName). On accepte les deux : si companyId
    // fourni, le serveur écrasera companyName par la raison sociale officielle
    // pour cohérence.
    companyId: uuidSchema.optional().or(z.literal('')).transform((v) => (v ? v : undefined)),
    companyName: z.string().trim().min(2, 'Nom de l’entreprise requis.').max(200),
    contactFirstName: z.string().trim().min(1).max(100),
    contactLastName: z.string().trim().min(1).max(100),
    contactRole: z.string().trim().max(150).optional().or(z.literal('')),
    contactEmail: z.string().trim().email('Email invalide.').optional().or(z.literal('')),
    relationType: connectionRelationTypeSchema,
    period: z.string().trim().max(60).optional().or(z.literal('')),
    notes: z.string().trim().max(500).optional().or(z.literal('')),
});
export const connectionUpdateSchema = connectionCreateSchema.partial();
//# sourceMappingURL=connection.js.map